export const hrefTargetAndRelHelper = {
    target: '_blank',
    rel: 'noopener noreferrer'
};